import React, { useState, useEffect, useRef } from 'react';
import { Link, Navigate, useNavigate, Routes, Route } from "react-router-dom";
import axios from 'axios';
import Swal from 'sweetalert2';
import MasterDashboardLayout from '../../AdminPanel/MasterDashboardLayout'

import { DataGrid } from '@mui/x-data-grid';

function ViewTestimonial() {
    const navigate = useNavigate();
    const [renderData, setRenderData] = useState('')
    const columns = [
        { field: 'id', headerName: 'ID', width: 70, padding: 50 },
        { field: 'testimonial_short_bio', headerName: 'Short bio', width: 100 },
        { field: 'client_message', headerName: 'Client message', width: 130 },
        { field: 'client_name', headerName: 'Client name', width: 130 },
        { field: 'client_company_name', headerName: 'Compnay name', width: 130 },
        { field: 'client_designation', headerName: 'Client designation', width: 130 },

        {
            field: 'client_image',
            headerName: 'Image',
            sortable: false,
            width: 160,
            renderCell: (params) => <img className="rounded " src={`${global.img_url}/images/${params.row.client_image}`} width="100px" height="70px" alt="No Image" />,
            // renderCell: (params) => console.log('baaal',params.row)
        },
        {
            headerName: 'Action',
            renderCell: (params) =>
                <div class="fs-6" style={{ cursor: 'pointer' }}>
                    <Link to={`/edit-testimonial/${params.id}`}><i class="fa text-warning fa-edit"></i></Link>
                    <i class="fa text-danger fa-trash mx-2" onClick={(e) => deleteTestimonial(e, params.id)}></i>
                </div>
        },
    ];

    const [allTestimonial, setAllTestimonial] = useState([]);
    console.log('all testi', allTestimonial)
    useEffect(() => {
        axios.get(`/api/all-testimonial`).then(res => {
            if (res.data.status == 200) {
                setAllTestimonial(res.data.all_testimonial);
                // setLoading(false);

            }
        })
    }, [renderData])

    //delete functionality start 

    const deleteTestimonial = (e, id) => {
        e.preventDefault();
        const thisClicked = e.currentTarget;
        //  thisClicked.innerText = "Deleting";

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post(`/api/delete-testimonial/${id}`).then(res => {
                    if (res.data.status === 200) {
                        setRenderData(res.data)
                        thisClicked.closest("tr").remove();

                        //   swal("Success", res.data.message, "success");
                    }
                });
                Swal.fire(
                    'Deleted!',
                    'Your data has been deleted.',
                    'success'
                )
            }
        })

    }


    return (
        <MasterDashboardLayout>
            <div class="col-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-body">
                        <div className='d-flex justify-content-between my-2'>
                            <h4 class="card-title">View Testimonial</h4>
                            <Link to="/add-testimonial"><button type='button' className='btn btn-warning btn-sm fw-bold rounded-pill'>Create</button></Link>
                        </div>

                        <div style={{ height: '70vh', width: '100%' }}>
                            <DataGrid
                                rows={allTestimonial}
                                columns={columns}
                                pageSize={5}
                                rowHeight={100}
                                rowsPerPageOptions={[5]}
                            // checkboxSelection
                            />
                        </div>
                    </div>
                </div>
            </div>
        </MasterDashboardLayout>
    )
}

export default ViewTestimonial